import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import { calculateSpacing } from '@vds-core/theme';
var propTypes = {
  /**
   * If provided, width of Checkbox components will be rendered based on this value
   */
  width: PropTypes.string,

  /**
   * @ignore
   * If provided a new Checkbox element will render
   */
  Checkbox: PropTypes.func,

  /**
   * @ignore
   * Padding bottom of the last element of a CheckBoxGroup
   */
  lastChildPadding: PropTypes.string
};
var defaultProps = {
  lastChildPadding: '6X',
  width: '100%'
};
var GAP = '6X';
var CheckboxWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "CheckboxWrapper",
  componentId: "uwlu6s-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 1;\n  padding: 0 0 ", " 0;\n  width: 100%;\n\n  > * {\n    margin-bottom: 0;\n  }\n\n  &:last-child {\n    padding-bottom: ", ";\n  }\n"])), calculateSpacing(GAP, 'rem'), function (_ref) {
  var lastChildPadding = _ref.lastChildPadding;
  return lastChildPadding === '0' ? 0 : calculateSpacing(lastChildPadding, 'rem');
});

var CheckboxGroupItem = function CheckboxGroupItem(props) {
  function _onClick(e) {
    if (e.type === 'click' && e.detail !== 0) {
      // This is a real click. Do something here
      e.currentTarget.blur();
    }
  }

  var Checkbox = props.Checkbox,
      lastChildPadding = props.lastChildPadding;
  return /*#__PURE__*/React.createElement(CheckboxWrapper, {
    "data-testid": "test-group-item",
    lastChildPadding: lastChildPadding,
    onClick: _onClick
  }, /*#__PURE__*/React.createElement(Checkbox, props));
};

CheckboxGroupItem.propTypes = propTypes;
CheckboxGroupItem.defaultProps = defaultProps;
export default CheckboxGroupItem;